import { useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { AppContext, ADD_OR_UPDATE_PLANT, SET_CHOSEN_PLANTS } from '../context/AppContext';
import gardenBedLayouts from '../data/gardenBedLayouts.json';
import { isNilOrEmpty } from '../utils';

export function useGardenBed() {
	const { state, dispatch } = useContext(AppContext);
	const { bedConfig, chosenPlants } = state.currentDesign;
	const [shape, setShape] = useState(null);
	const [size, setSize] = useState(null);
	const [style, setStyle] = useState(null);
	const [plantCategories, setPlantCategories] = useState([]);

  const setChosenPlants = (chosenPlants) => {
    dispatch({
      type: SET_CHOSEN_PLANTS,
      payload: chosenPlants,
    });
  }

	// Load initial garden bed
	useEffect(() => {
		if (bedConfig) {
			console.log('Initializing selectedPlants for bedConfig:', bedConfig);
			const layout = gardenBedLayouts.find((bed) => bed.id === bedConfig);
			if (layout) {
				setShape(layout.shape);
				setSize(layout.size);
				setStyle(layout.style);
				setPlantCategories(layout.plants);

        if (isNilOrEmpty(chosenPlants)) {
          const initialSelections = layout.plants.map(({ category, quantity }) => ({
            category,
            plantId: null,
            quantity,
          }));
          console.log('Initial selectedPlants array:', initialSelections);
          setChosenPlants(initialSelections);
        }
			} else {
				console.log('No matching garden bed layout found for bedConfig:', bedConfig);
			}
		}
	}, [bedConfig]);

	const addOrReplacePlant = useCallback(
		(plantId, category) => {
			console.log('Inside addOrReplacePlant with:', { plantId, category });
				const existingIndex = chosenPlants.findIndex((p) => p.category === category);
				console.log('existingIndex:', existingIndex);

				if (existingIndex >= 0) {
					const updatedPlants = [...chosenPlants];
					const quantity = updatedPlants[existingIndex].quantity;
					updatedPlants[existingIndex] = { ...updatedPlants[existingIndex], plantId };
					console.log('Dispatching ADD_OR_UPDATE_PLANT with payload:', { category, plantId, quantity });
					dispatch({
						type: ADD_OR_UPDATE_PLANT,
						payload: { category, plantId, quantity },
					});
					return updatedPlants;
				}
				return chosenPlants;
			
		},
		[dispatch, chosenPlants]
	);

	return {
		chosenPlants,
		addOrReplacePlant,
		plantCategories,
	};
}

export default useGardenBed;
